import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import "./cryptolicense.css";
import ServiceFooter from "../../ServiceFooter";
import { useState } from "react";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import {
  benefitsData,
  cryptoTradingCost,
  howGetData,
  licenseCostIndia,
  stepsData,
} from "./data";

const Cryptolicense = () => {
  // type
  const [isPrevTypeDisabled, setIsPrevTypeDisabled] = useState(true);
  const [isNextTypeDisabled, setIsNextTypeDisabled] = useState(false);

  const handleTypeChange = (TypeSwiper) => {
    setIsPrevTypeDisabled(TypeSwiper.isBeginning);
    setIsNextTypeDisabled(TypeSwiper.isEnd);
  };

  // doc req
  const [isPrevDocDisabled, setIsPrevDocDisabled] = useState(true);
  const [isNextDocDisabled, setIsNextDocDisabled] = useState(false);

  const handleDocChange = (DocSwiper) => {
    setIsPrevDocDisabled(DocSwiper.isBeginning);
    setIsNextDocDisabled(DocSwiper.isEnd);
  };

  return (
    <>
      <NewHead />

      <Helmet>
        <title>Crypto Licensing</title>

        <meta name="title" content="Crypto Licensing" />
        <meta
          name="description"
          content="Stay Compliant with our Crypto Licensing Service. Talk to our Experts."
        />

        <meta property="og:title" content="Crypto Licensing" />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/crypto-licensing"
        />
      </Helmet>

      <main className="crypto-license_main">
        {/* hero */}
        <div className="primary__landing__container">
          <div className="cr_li_hero_wrapper cr_li_mb_80">
            <h1 className="fiu-hero-title cr_hero_title">Crypto Licensing</h1>
            <p className="fiu-hero-content cr_hero_content">
              Looking to launch a crypto business legally and securely or
              planning to start a crypto exchange from Development to Crypto
              Licensing we cover it for you.
            </p>
            <button
              data-toggle="modal"
              data-target="#myModal"
              className="mt-2 career-btn re-hero-btn"
            >
              <div className="re-btn-txt">Get Free Consultation </div>
              <span className="mx-2 right-arr">
                <i className="fa-solid fa-arrow-right"></i>
              </span>
            </button>
          </div>
        </div>

        {/* about */}
        <div className="cr_li_about">
          <div className="primary__landing-content-container">
            <div className="row g-3">
              <div className="col-lg-4">
                <h3 className="cr_li_subtitle">What Is Crypto Licensing?</h3>
              </div>
              <div className="col-lg-8">
                <p className="cr_li_subcontent">
                  Crypto licensing refers to the legal permission or
                  authorization granted by a regulatory body or government
                  agency that allows a business or individual to operate a
                  cryptocurrency exchange, offer crypto trading services, or
                  manage digital assets.
                </p>
                <p className="cr_li_subcontent">
                  Obtaining a crypto license proves that your crypto-related
                  business complies with national and international regulations.
                  It helps prevent illegal activities such as money laundering,
                  fraud, and terrorism financing.
                </p>
              </div>
            </div>
          </div>

          <img
            src={require("../../../image/cryptolicense/cr_li_about_imgNew.webp")}
            alt="Crypto Licensing"
            className="cr_li_about_img"
          />
        </div>

        {/* why important */}
        <div className="cr_li_imp cr_li_mb_100">
          <div className="primary__landing-content-container">
            <h3 className="cr_li_subtitle cr_imp_title">
              Why Crypto Licensing Is Important
            </h3>

            <div className="row mx-0 g-4 cr_imp_row">
              <div className="col-lg-3 col-sm-6">
                <div className="cr_imp_card">
                  <div className="imp_img_wrap">
                    <img
                      src={require("../../../image/cryptolicense/imp-img-one.webp")}
                      alt="Crypto Licensing"
                    />
                  </div>
                  <h5>Legal Compliance</h5>
                  <p>A licensed platform operates within the law.</p>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="cr_imp_card">
                  <div className="imp_img_wrap">
                    <img
                      src={require("../../../image/cryptolicense/imp-img-two.webp")}
                      alt="Crypto Licensing"
                    />
                  </div>
                  <h5>Trust and Transparency</h5>
                  <p>Customers feel safer when using a licensed exchange.</p>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="cr_imp_card">
                  <div className="imp_img_wrap">
                    <img
                      src={require("../../../image/cryptolicense/imp-img-three.webp")}
                      alt="Crypto Licensing"
                    />
                  </div>
                  <h5>Partnerships</h5>
                  <p>
                    Banks and payment providers prefer working with licensed
                    platforms.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="cr_imp_card">
                  <div className="imp_img_wrap">
                    <img
                      src={require("../../../image/cryptolicense/imp-img-four.webp")}
                      alt="Crypto Licensing"
                    />
                  </div>
                  <h5>Avoiding Penalties</h5>
                  <p>
                    Running a crypto business without a proper license can
                    result in heavy fines or forced closure.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="cr_imp_btn_wrap">
            <button
              data-toggle="modal"
              data-target="#myModal"
              className="custom-ai-btn re-hero-btn"
            >
              {" "}
              <div className="re-btn-txt">Know More</div>
              <span className="mx-2 right-arr">
                <i className="fa-solid fa-arrow-right"></i>
              </span>
            </button>
          </div>
        </div>

        {/* types */}
        <div className="cr_li_type cr_li_mb_80">
          <div className="primary__landing-content-container">
            <div className="row fiu-need-row cr_li_type_row">
              <div className="col-lg-6">
                <div className="fiu-need-left">
                  <h4 className="cr_li_subtitle">Types of Crypto Licensing</h4>
                  <p className="cr_li_subcontent">
                    Different countries offer various types of crypto licensing
                    based on the nature of the business
                  </p>
                  <button
                    data-toggle="modal"
                    data-target="#myModal"
                    className="custom-ai-btn re-hero-btn"
                  >
                    {" "}
                    <div className="re-btn-txt">Contact Us</div>
                    <span className="mx-2 right-arr">
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </button>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="fiu-need-right cr_type_right">
                  <div className="fiu-need-right-contents">
                    <img
                      src={require("../../../image/cryptolicense/type-img-one.webp")}
                      alt="FIU Consultant"
                    />
                    <h6 className="fiu-need-right-title">
                      Virtual Currency Exchange License
                    </h6>
                    <p className="cr_li_type_content">
                      Required for crypto exchanges offering crypto-to-crypto or
                      crypto-to-fiat trading.
                    </p>
                  </div>
                  <div className="fiu-need-right-contents">
                    <img
                      src={require("../../../image/cryptolicense/type-img-two.webp")}
                      alt="FIU Consultant"
                    />
                    <h6 className="fiu-need-right-title">
                      Crypto Wallet License
                    </h6>
                    <p className="cr_li_type_content">
                      Needed for businesses offering digital wallets for holding
                      or transferring crypto assets.
                    </p>
                  </div>
                  <div className="fiu-need-right-contents">
                    <img
                      src={require("../../../image/cryptolicense/type-img-three.webp")}
                      alt="FIU Consultant"
                    />
                    <h6 className="fiu-need-right-title">Custodian License</h6>
                    <p className="cr_li_type_content">
                      Required for platforms that hold crypto assets on behalf
                      of customers.
                    </p>
                  </div>
                  <div className="fiu-need-right-contents">
                    <img
                      src={require("../../../image/cryptolicense/type-img-four.webp")}
                      alt="FIU Consultant"
                    />
                    <h6 className="fiu-need-right-title">ICO/STO License</h6>
                    <p className="cr_li_type_content">
                      Regulates token launches, especially when securities are
                      involved.
                    </p>
                  </div>
                  <div className="fiu-need-right-contents">
                    <img
                      src={require("../../../image/cryptolicense/type-img-five.webp")}
                      alt="FIU Consultant"
                    />
                    <h6 className="fiu-need-right-title">
                      DeFi Platform License
                    </h6>
                    <p className="cr_li_type_content">
                      Governs decentralized finance platforms operating under
                      regulated environments.
                    </p>
                  </div>
                  <div className="fiu-need-right-contents">
                    <img
                      src={require("../../../image/cryptolicense/type-img-six.webp")}
                      alt="FIU Consultant"
                    />
                    <h6 className="fiu-need-right-title">
                      Payment Gateway License
                    </h6>
                    <p className="cr_li_type_content">
                      Required for accepting crypto as a form of payment and
                      converting it to fiat.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* benefits */}
        <div className="cr_li_ben_wrap cr_li_mb_100">
          <div className="primary__landing-content-container">
            <h3 className="cr_li_subtitle cr_ben_title text-center">
              Benefits of Crypto Licensing
            </h3>
            <p className="cr_li_subcontent cr_ben_content">
              Obtaining crypto licensing can offer major benefits to your
              business.
            </p>

            <>
              <Swiper
                spaceBetween={30}
                slidesPerView={4}
                modules={[Navigation]}
                navigation={{
                  prevEl: ".cr_ben_prev",
                  nextEl: ".cr_ben_nxt",
                }}
                breakpoints={{
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                  },
                  480: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                  1025: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                  },
                  1200: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                  },
                }}
                onSlideChange={handleTypeChange}
                onReachBeginning={() => setIsPrevTypeDisabled(true)}
                onReachEnd={() => setIsNextTypeDisabled(true)}
                onFromEdge={() => {
                  setIsPrevTypeDisabled(false);
                  setIsNextTypeDisabled(false);
                }}
              >
                <SwiperSlide>
                  <div className="cr_li_ben_card cr_ben_one">
                    <p className="cr_li_ben_content">
                      Legal authorization to operate
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="cr_li_ben_card cr_ben_two">
                    <p className="cr_li_ben_content">
                      Protection from regulatory penalties
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="cr_li_ben_card cr_ben_three">
                    <p className="cr_li_ben_content">
                      Enhanced brand trust and reputation
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="cr_li_ben_card cr_ben_four">
                    <p className="cr_li_ben_content">
                      Access to global crypto markets
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="cr_li_ben_card cr_ben_five">
                    <p className="cr_li_ben_content">
                      Opportunities for bank partnerships
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="cr_li_ben_card cr_ben_six">
                    <p className="cr_li_ben_content">
                      Ability to list on app stores and marketplaces
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="cr_li_ben_card cr_ben_seven">
                    <p className="cr_li_ben_content">
                      Easier fundraising and investor confidence
                    </p>
                  </div>
                </SwiperSlide>
              </Swiper>

              <div className="fd-step-btn-wrap">
                <button
                  className={`cr_ben_prev ${
                    isPrevTypeDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isPrevTypeDisabled ? "#0000008f" : "#000",
                    cursor: isPrevTypeDisabled ? "not-allowed" : "pointer",
                  }}
                >
                  <i className="fa-solid fa-arrow-left"></i>
                </button>
                <button
                  className={`cr_ben_nxt ${
                    isNextTypeDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isNextTypeDisabled ? "#0000008f" : "#000",
                    cursor: isNextTypeDisabled ? "not-allowed" : "pointer",
                  }}
                >
                  <i className="fa-solid fa-arrow-right"></i>
                </button>
              </div>
            </>
          </div>
        </div>

        {/* process */}
        <div className="cr_li_process cr_li_mb_80">
          <div className="primary__landing-content-container">
            <h3 className="cr_li_subtitle text-center">
              Crypto Licensing Process
            </h3>
            <p className="cr_li_subcontent cr_li_process_subcontent">
              Getting crypto licensing is a multi-step process. Here's a general
              overview
            </p>

            <div className="row g-4 cr_process_row">
              <div className="col-lg-4 col-sm-6">
                <div className="cr_process_card">
                  <span>01</span>
                  <h5>Choose Your Jurisdiction</h5>
                  <p>
                    Evaluate the pros and cons of each country that offers
                    crypto licensing and choose the one that aligns with your
                    business model.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="cr_process_card">
                  <span>02</span>
                  <h5>Company Formation</h5>
                  <p>
                    Register a legal entity in the chosen jurisdiction. This is
                    important for crypto licensing Process.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="cr_process_card">
                  <span>03</span>
                  <h5>Prepare Documentation</h5>
                  <p>
                    Compile necessary documents including business plan,
                    compliance policies, AML/KYC procedures, team information,
                    etc.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="cr_process_card">
                  <span>04</span>
                  <h5>Apply for License</h5>
                  <p>
                    Submit your crypto licensing application to the appropriate
                    regulatory authority.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="cr_process_card">
                  <span>05</span>
                  <h5>Due Diligence</h5>
                  <p>
                    Authorities will verify your application, perform background
                    checks, and assess your compliance setup.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="cr_process_card">
                  <span>06</span>
                  <h5>Receive Your Crypto License</h5>
                  <p>
                    If everything is satisfactory, your business will receive
                    the official crypto licensing approval.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="cr_cst_wrap">
          {/* cost */}
          <div className="cr_li_cost cr_li_mb_80">
            <div className="primary__landing-content-container">
              <h3 className="cr_li_subtitle text-center">
                Cost of Crypto Licensing in 2025
              </h3>
              <p className="cr_li_subcontent cr_cost_content">
                The cost of crypto licensing depends on factors such as the
                chosen jurisdiction, type of license, legal and consultancy
                fees, and compliance needs. Here’s an approximate breakdown.
              </p>

              <div className="cr_cost_row_outer">
                <div className="row g-4 cr_cost_row">
                  <div className="col-lg-4 col-sm-6">
                    <div className="cr_cost_card">
                      <div className="cr_cost_top co_one">Country</div>
                      <div className="cr_cost_bottom">
                        <p>India (FIU)</p>
                        <p>Dubai (VARA)</p>
                        <p>Singapore</p>
                        <p>USA</p>
                        <p>UK</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-6">
                    <div className="cr_cost_card">
                      <div className="cr_cost_top co_two">
                        Approx. Cost (USD)
                      </div>
                      <div className="cr_cost_bottom">
                        <p>$5,000 - $10,000</p>
                        <p>$10,000 - $50,000</p>
                        <p>$50,000+</p>
                        <p>$100,000+</p>
                        <p>$50,000+</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-6">
                    <div className="cr_cost_card">
                      <div className="cr_cost_top co_two">Timeline</div>
                      <div className="cr_cost_bottom">
                        <p>2-6 months</p>
                        <p>3-6 months</p>
                        <p>4-6 months</p>
                        <p>6-12 months</p>
                        <p>4-6 months</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <p className="cr_li_subcontent cr_cost_bt">
                These are approximate costs including government fees, legal
                assistance, and consulting.
              </p>
            </div>
          </div>

          <div className="cr_li_mb_80">
            <div className="primary__landing-content-container">
              <div className="row g-3">
                <div className="col-lg-5">
                  <h3 className="cr_li_subtitle cr_in_mw">
                    Crypto Licensing in India
                  </h3>
                </div>
                <div className="col-lg-7">
                  <p className="cr_li_subcontent">
                    India has seen significant growth in the crypto sector.
                    However, the regulations are evolving. Businesses operating
                    in crypto must follow specific guidelines and acquire proper
                    crypto licensing.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="cr_hw_wrap">
            <div className="primary__landing-content-container">
              {/* how to get */}
              <h3 className="cr_li_subtitle cr_hw_title">
                How to Get a Crypto Exchange License in India
              </h3>
              <p className="cr_li_subcontent cr_hw_content">
                Getting a crypto exchange license in India is not as
                straightforward as in countries like Dubai. However, there is a
                process to follow to ensure your exchange operates legally.
              </p>

              <div className="cr_hw_outer">
                <div className="row g-3">
                  <div className="col-lg-5">
                    <h3 className="cr_li_subtitle cr_fz_32">
                      How to Get a Crypto Exchange License in India
                    </h3>
                  </div>
                  <div className="col-lg-7">
                    <p className="cr_li_subcontent">
                      If you want to know how to get a crypto exchange license
                      in India, here’s a simple step-by-step guide
                    </p>
                  </div>
                </div>

                <div className="row g-lg-5 g-4 cr_hw_row">
                  {howGetData.map((data) => {
                    return (
                      <div key={data.id} className="col-lg-4 col-sm-6">
                        <div className="cr_hw_card">
                          <img src={data.icon} alt="Crypto Licensing" />
                          <h5>{data.title}</h5>
                          <p>{data.description}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <p className="cr_li_subcontent cr_hw_bt_ct">
                  After completing all these steps, you’ll be legally authorized
                  to run your exchange in India.
                </p>
              </div>

              {/* about cost */}
              <div className="cr_abt_ct_wrap">
                <div className="row g-3">
                  <div className="col-lg-5">
                    <h3 className="cr_li_subtitle cr_abt_clr cr_fz_32">
                      What is the crypto exchange license cost in India?
                    </h3>
                  </div>
                  <div className="col-lg-7">
                    <p className="cr_li_subcontent cr_abt_clr-two">
                      The cost can vary depending on the scale of operations and
                      services offered. On average, the crypto exchange license
                      cost in India includes
                    </p>
                  </div>
                </div>

                <div className="row g-4 cr_li_row">
                  <div className="col-lg-6">
                    <img
                      src={require("../../../image/cryptolicense/abt_costImgNew.webp")}
                      alt="Crypto Licensing"
                      className="w-100"
                    />
                  </div>
                  <div className="col-lg-6 d-flex  align-items-lg-center justify-content-lg-center">
                    <div className="cr_list_wrap">
                      {licenseCostIndia.map((data) => {
                        return (
                          <div key={data.id} className="cr_lists">
                            <span>
                              <i className="fa-solid fa-check"></i>
                            </span>
                            <h6>{data.content}</h6>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>

                <p className="cr_li_subcontent cr_hw_bt_ct cr_abt_clr">
                  So, the crypto trading license India cost or crypto exchange
                  license cost in India may range from 10,000$ or more based on
                  requirements.
                </p>
              </div>
            </div>

            <div className="cr_hw_wrap_grad"></div>
          </div>

          <div className="cr_cst_grad"></div>
        </div>

        <div className="primary__landing-content-container">
          <div className="cr_ct_india">
            <h3 className="cr_li_subtitle text-center">
              Crypto Trading License India
            </h3>
            <p className="cr_li_subcontent cr_ind_cnt">
              To offer crypto trading in India, a business needs to comply with
              regulations and secure a crypto trading license India or operate
              under legal business frameworks with FIU registration.
            </p>
          </div>
        </div>

        {/* steps */}
        <div className="primary__landing-content-container">
          <div className="cr_steps_wrap cr_li_mb_100">
            <h3 className="cr_li_subtitle cr_step_title cr_fz_40">
              Steps For Getting a Crypto Trading License in India
            </h3>
            <p className="cr_li_subcontent text-center mt-2">
              To operate legally, businesses must
            </p>

            <div className="row g-4 cr_steps_row">
              {stepsData.map((data) => {
                return (
                  <div key={data.id} className="col-lg-4 col-sm-6">
                    <div className="cr_steps_card">
                      <span>{data.num}</span>
                      <p>{data.content}</p>

                      {/* <img
                        src={data.img}
                        alt="Crypto Licensing"
                        className="cr_step_img"
                      /> */}
                    </div>
                  </div>
                );
              })}
            </div>

            <p className="cr_li_subcontent cr_hw_bt_ct">
              By following this process, you can acquire a crypto trading
              license in India and operate legally.
            </p>

            <div className="cr_st_gr_lft"></div>
            <div className="cr_st_gr_rgt"></div>
          </div>
        </div>

        {/* india cost */}
        <div className="cr_in_cst_wrap cr_li_mb_100">
          <div className="primary__landing-content-container">
            <h3 className="cr_li_subtitle text-center">
              Crypto Trading License India Cost
            </h3>
            <p className="cr_li_subcontent text-center">
              The crypto trading license India cost depends on the following
            </p>

            <div className="row g-4 cr_li_row">
              <div className="col-lg-6">
                <img
                  src={require("../../../image/cryptolicense/crypTradLicCost.webp")}
                  alt="Crypto Licensing"
                  className="w-100"
                />
              </div>
              <div className="col-lg-6 d-flex  align-items-lg-center justify-content-lg-center">
                <div className="cr_list_wrap">
                  {cryptoTradingCost.map((data) => {
                    return (
                      <div key={data.id} className="cr_lists">
                        <span>
                          <i className="fa-solid fa-check"></i>
                        </span>
                        <h6 className="text-white">{data.content}</h6>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            <p className="cr_li_subcontent cr_hw_bt_ct cr_td_mw">
              On average, the cost can be anywhere between 10,000$ depending on
              the scale.
            </p>
          </div>
        </div>

        {/* crypto license dubai */}
        <div className="cr_lic_db cr_li_mb_80">
          <div className="primary__landing-content-container">
            <h3 className="cr_li_subtitle text-center">
              Crypto Licensing in Dubai
            </h3>
            <p className="cr_li_subcontent cr_db_content">
              Dubai is one of the most crypto-friendly regions in the world. It
              offers clear and supportive regulatory frameworks through the
              Virtual Assets Regulatory Authority (VARA).
            </p>

            <div className="cr_step_db_wrap">
              <div className="row g-4 ">
                <div className="col-lg-6">
                  <div className="cr_st_db">
                    <h3 className="cr_li_subtitle cr_fz_32">
                      Steps For Obtaining a Crypto Trading License in Dubai
                    </h3>
                    <p className="cr_li_subcontent">
                      Once approved, you can legally operate a crypto business
                      in Dubai.
                    </p>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="cr_st_db_cards st_card_one">
                    <img
                      src={require("../../../image/cryptolicense/db-st-img-one.webp")}
                      alt="Crypto Licensing"
                    />
                    <h5>Choose Business Activity</h5>
                    <p>
                      Select “Crypto Trading” or “Crypto Exchange” as your
                      business activity.
                    </p>
                  </div>
                  <div className="cr_st_db_cards st_card_two">
                    <img
                      src={require("../../../image/cryptolicense/db-st-img-two.webp")}
                      alt="Crypto Licensing"
                    />
                    <h5>Select Free Zone</h5>
                    <p>
                      Choose a suitable free zone like DMCC, IFZA, or Dubai
                      Mainland.
                    </p>
                  </div>
                  <div className="cr_st_db_cards st_card_three">
                    <img
                      src={require("../../../image/cryptolicense/db-st-img-three.webp")}
                      alt="Crypto Licensing"
                    />
                    <h5>Submit Application to VARA</h5>
                    <p>
                      Apply for a crypto license from the Virtual Assets
                      Regulatory Authority.
                    </p>
                  </div>
                  <div className="cr_st_db_cards st_card_four">
                    <img
                      src={require("../../../image/cryptolicense/db-st-img-four.webp")}
                      alt="Crypto Licensing"
                    />
                    <h5>Provide KYC/AML Compliance</h5>
                    <p>Submit compliance policies.</p>
                  </div>
                  <div className="cr_st_db_cards st_card_five">
                    <img
                      src={require("../../../image/cryptolicense/db-st-img-five.webp")}
                      alt="Crypto Licensing"
                    />
                    <h5>Pay Fees and Submit Documents</h5>
                    <p>Pay licensing fees and complete documentation.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="primary__landing-content-container">
            <div className="cr_ben_db_wrap">
              <div className="row g-4 cr_ben_db_row">
                <div className="col-lg-6">
                  <img
                    src={require("../../../image/cryptolicense/benefits-dbNew.webp")}
                    className="w-100"
                    alt="Crypto Licensing"
                  />
                </div>
                <div className="col-lg-6 cr_ben_db_col">
                  <h3 className="cr_li_subtitle cr_abt_clr cr_fz_32 cr_bn_db_title">
                    Benefits of Crypto Trading License Dubai
                  </h3>

                  <div className="cr_list_wrap">
                    {benefitsData.map((data) => {
                      return (
                        <div key={data.id} className="cr_lists">
                          <span>
                            <i className="fa-solid fa-check"></i>
                          </span>
                          <h6>{data.content}</h6>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* doc req */}
        <div className="primary__landing-content-container cr_li_mb_80">
          <h3 className="cr_li_subtitle text-center">
            Documents Required for Crypto Licensing
          </h3>
          <p className="cr_li_subcontent cr_doc_content">
            Whether you’re applying in India or Dubai, here are the common
            documents required for crypto licensing
          </p>

          <>
            <Swiper
              spaceBetween={30}
              slidesPerView={4}
              modules={[Navigation]}
              navigation={{
                prevEl: ".cr_doc_prev",
                nextEl: ".cr_doc_nxt",
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                480: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1025: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                },
                1200: {
                  slidesPerView: 4,
                  spaceBetween: 30,
                },
              }}
              onSlideChange={handleDocChange}
              onReachBeginning={() => setIsPrevDocDisabled(true)}
              onReachEnd={() => setIsNextDocDisabled(true)}
              onFromEdge={() => {
                setIsPrevDocDisabled(false);
                setIsNextDocDisabled(false);
              }}
            >
              <SwiperSlide>
                <div className="cr_li_ben_card cr_doc_one">
                  <p className="cr_li_ben_content">Passport and ID proofs</p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="cr_li_ben_card cr_doc_two">
                  <p className="cr_li_ben_content">
                    Company incorporation certificate
                  </p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="cr_li_ben_card cr_doc_three">
                  <p className="cr_li_ben_content">Business plan</p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="cr_li_ben_card cr_doc_four">
                  <p className="cr_li_ben_content">AML/KYC policy</p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="cr_li_ben_card cr_doc_five">
                  <p className="cr_li_ben_content">Bank account details</p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="cr_li_ben_card cr_doc_six">
                  <p className="cr_li_ben_content">
                    FIU or VARA registration documents.
                  </p>
                </div>
              </SwiperSlide>
            </Swiper>

            <div className="fd-step-btn-wrap">
              <button
                className={`cr_doc_prev ${isPrevDocDisabled ? "disabled" : ""}`}
                style={{
                  color: isPrevDocDisabled ? "#ffffff8f" : "#fff",
                  cursor: isPrevDocDisabled ? "not-allowed" : "pointer",
                }}
              >
                <i className="fa-solid fa-arrow-left"></i>
              </button>
              <button
                className={`cr_doc_nxt ${isNextDocDisabled ? "disabled" : ""}`}
                style={{
                  color: isNextDocDisabled ? "#ffffff8f" : "#fff",
                  cursor: isNextDocDisabled ? "not-allowed" : "pointer",
                }}
              >
                <i className="fa-solid fa-arrow-right"></i>
              </button>
            </div>
          </>
        </div>

        {/* tips */}
        <div className="cr_li_imp cr_li_mb_100">
          <div className="primary__landing-content-container">
            <h3 className="cr_li_subtitle cr_tip_title">
              Tips to Make Crypto Licensing Easier
            </h3>

            <div className="row mx-0 g-4 cr_imp_row">
              <div className="col-lg-3 col-sm-6">
                <div className="cr_imp_card">
                  <div className="imp_img_wrap">
                    <img
                      src={require("../../../image/cryptolicense/tip-img-one.webp")}
                      alt="Crypto Licensing"
                    />
                  </div>
                  <h5>Hire Experts</h5>
                  <p>
                    Use legal consultants who specialize in crypto licensing.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="cr_imp_card">
                  <div className="imp_img_wrap">
                    <img
                      src={require("../../../image/cryptolicense/tip-img-two.webp")}
                      alt="Crypto Licensing"
                    />
                  </div>
                  <h5>Stay Updated</h5>
                  <p>Laws change quickly—always stay informed.</p>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="cr_imp_card">
                  <div className="imp_img_wrap">
                    <img
                      src={require("../../../image/cryptolicense/tip-img-three.webp")}
                      alt="Crypto Licensing"
                    />
                  </div>
                  <h5>Use Technology</h5>
                  <p>Automate KYC/AML and data compliance.</p>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="cr_imp_card">
                  <div className="imp_img_wrap">
                    <img
                      src={require("../../../image/cryptolicense/tip-img-four.webp")}
                      alt="Crypto Licensing"
                    />
                  </div>
                  <h5>Join Crypto Associations</h5>
                  <p>
                    Stay connected with industry leaders and government updates.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="cr_imp_btn_wrap">
            <button
              data-toggle="modal"
              data-target="#myModal"
              className="custom-ai-btn re-hero-btn"
            >
              {" "}
              <div className="re-btn-txt">Know More</div>
              <span className="mx-2 right-arr">
                <i className="fa-solid fa-arrow-right"></i>
              </span>
            </button>
          </div>
        </div>

        {/* cost */}
        <div className="cr_li_mb_80">
          <div className="primary__landing-content-container">
            <h3 className="cr_li_subtitle text-center">
              Crypto Licensing Global Outlook
            </h3>
            <p className="cr_li_subcontent cr_cost_content">
              Countries around the world are working to regulate crypto
            </p>

            <div className="cr_cost_row_outer">
              <div className="row g-4 cr_cost_row">
                <div className="col-lg-4 col-sm-6">
                  <div className="cr_cost_card">
                    <div className="cr_cost_top co_one">Country</div>
                    <div className="cr_cost_bottom">
                      <p>India </p>
                      <p>Dubai </p>
                      <p>USA</p>
                      <p>UK</p>
                      <p>Singapore</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6">
                  <div className="cr_cost_card">
                    <div className="cr_cost_top co_two">
                      Licensing Authority
                    </div>
                    <div className="cr_cost_bottom">
                      <p>FIU-IND</p>
                      <p>VARA</p>
                      <p>FinCEN, SEC</p>
                      <p>FCA</p>
                      <p>MAS</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6">
                  <div className="cr_cost_card">
                    <div className="cr_cost_top co_two">Status</div>
                    <div className="cr_cost_bottom">
                      <p>Regulated Partially</p>
                      <p>Fully regulated</p>
                      <p>Regulated</p>
                      <p>Regulated</p>
                      <p>Regulated</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Take Away*/}
        <div className="rs-mt-100 custom-get-in-touch ply-ta ml-mt-0">
          <div className="primary__landing-content-container ">
            <h5 className="custom-get-title ph-take-title dt-get-title">
              Take Away
            </h5>
            <p className="custom-get-content dt-get-content">
              Crypto licensing is the foundation for starting a legal, secure,
              and trustworthy crypto business. Whether you're planning to launch
              a crypto exchange, trading platform, or wallet service, acquiring
              the right crypto license is essential. In India, you can obtain a
              crypto trading license in India and even a full crypto exchange
              license in India by registering with FIU, complying with AML/KYC
              guidelines, and fulfilling all regulatory requirements. Remember
              to calculate your crypto trading license India cost and crypto
              exchange license cost in India before starting your business.
            </p>

            <div className="d-flex align-items-center justify-content-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="fiu-need-left-btn mt-4 re-hero-btn"
              >
                <div className="re-btn-txt">Get Free Consultation</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </main>

      {/* faq */}
      <article className="primary__landing-content-container">
        <div className="landing-faq-wrapper">
          <div className="row">
            <div className="col-lg-6">
              <h6 className="landing-faq-left-title">
                Frequently Asked <span className="faq-span">Questions.</span>{" "}
                {""}
              </h6>
            </div>
            <div className="col-lg-6">
              <div>
                <div className="container">
                  <div className="accordion" id="faq">
                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead1">
                        <button
                          className="landing-faq-title collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#faq1"
                          aria-expanded="true"
                          aria-controls="faq1"
                        >
                          Is crypto licensing mandatory in India?
                        </button>
                      </div>

                      <div
                        id="faq1"
                        className="collapse"
                        aria-labelledby="faqhead1"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, to legally operate a crypto exchange or trading
                          business, you must register with FIU and comply with
                          KYC/AML norms.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead2">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq2"
                          aria-expanded="true"
                          aria-controls="faq2"
                        >
                          What is a crypto exchange license cost in India?
                        </div>
                      </div>

                      <div
                        id="faq2"
                        className="collapse"
                        aria-labelledby="faqhead2"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          The crypto exchange license cost in India ranges from
                          10,000 $, depending on legal and operational needs.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead3">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq3"
                          aria-expanded="true"
                          aria-controls="faq3"
                        >
                          Can I get a crypto trading license in Dubai easily?
                        </div>
                      </div>

                      <div
                        id="faq3"
                        className="collapse"
                        aria-labelledby="faqhead3"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes. Dubai’s VARA offers a straightforward path to
                          obtain a crypto trading license Dubai through free
                          zones and proper compliance.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead4">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq4"
                          aria-expanded="true"
                          aria-controls="faq4"
                        >
                          What is the crypto trading license India cost?
                        </div>
                      </div>

                      <div
                        id="faq4"
                        className="collapse"
                        aria-labelledby="faqhead4"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          The cost of a crypto trading license in India can be
                          approximately $10,000.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead5">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq5"
                          aria-expanded="true"
                          aria-controls="faq5"
                        >
                          How to obtain a crypto exchange license in India?
                        </div>
                      </div>

                      <div
                        id="faq5"
                        className="collapse"
                        aria-labelledby="faqhead5"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          To get a crypto exchange license in India, register
                          your business, get FIU registration, ensure KYC/AML
                          compliance, and pay relevant fees.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <ServiceFooter />
    </>
  );
};

export default Cryptolicense;
